import { render, staticRenderFns } from "./CampaignV2.vue?vue&type=template&id=facdf25e&scoped=true&"
import script from "./CampaignV2.vue?vue&type=script&lang=js&"
export * from "./CampaignV2.vue?vue&type=script&lang=js&"
import style0 from "./CampaignV2.vue?vue&type=style&index=0&id=facdf25e&prod&lang=scss&"
import style1 from "./CampaignV2.vue?vue&type=style&index=1&id=facdf25e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facdf25e",
  null
  
)

export default component.exports